<template>
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <slot name="table_cards_header">
                    <h5>Basic Table</h5>
                </slot>
                <div class="button-table-blocks">
                    <slot v-if="showTopButton" name="table_cards_header_buttons">
                        <button @click="topButtonClick" class="btn btn-outline-info">Create</button>
                    </slot>
                </div>
            </div>
            <div class="table-responsive custom-scrollbar">
                <table class="table">
                    <thead>
                        <slot name="table_rows_header">
                            <tr class="border-bottom-primary">
                                <th scope="col">Id</th>
                                <th scope="col">Name</th>
                                <th scope="col">Value</th>
                                <th scope="col">Data</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </slot>
                    </thead>
                    <tbody>
                        <slot name="table_rows_data">
                            <tr>
                                <td colspan="5" class="text-center">Table is empty</td>
                            </tr>
                        </slot>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BasicTable',
    props: {
        showTopButton: {
            default: false,
        },
    },
    methods: {
        topButtonClick: function () {
            this.$emit('top-button-click');
        }
    }
}
</script>

<style scoped>
.button-table-blocks {
    margin-left: auto;
}

.card {
    .card-header {
        display: flex;
        align-content: start;
        align-items: center;
    }
}
</style>
